"use client";
import { jsx as i } from "react/jsx-runtime";
import u from "clsx";
import { memo as d } from "react";
import { Box as f } from "../../blocks/base/Base.js";
import { s as r } from "../../Button.module-C3Ja-wjg.js";
const w = d(
  ({ wide: p, onClick: t, children: m, ...s }) => {
    const n = (e) => {
      var o;
      const a = e.currentTarget.getAttribute("data-event");
      a && ((o = window == null ? void 0 : window.dataLayer) == null || o.push({
        event: a
      })), t == null || t(
        e
      );
    };
    return /* @__PURE__ */ i(
      f,
      {
        gap: 0,
        row: !0,
        className: u(r.button_wrapper, {
          [r._wide]: p,
          [r._active]: t
        }),
        onClick: n,
        ...s,
        children: m
      }
    );
  }
);
w.displayName = "ButtonWrapper";
export {
  w as ButtonWrapper
};
